export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>SaaS/Webアプリケーションやファイル共有サービスを利用する今日のワーカー向けのインテリジェントな機能を備えた、中核となるワークスペースオファリングです。</p><p>あらゆるアプリケーション向け多要素認証をサポートするSSO、マイクロアプリケーションを伴うワークスペースインテリジェンス、パーソナライズされたフィード、バーチャルアシスタントに加えて、無制限のファイルストレージを備えたCitrix Content Collaboration Standard Serviceが含まれています。</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>きめ細かなセキュリティを備えた完全なデジタルワークスペースを必要としているが、仮想アプリケーションやデスクトップは必要としていないワーカー向けの包括的なワークスペースソリューションです。</p><p>Workspace Standardの機能に加えて、SaaSおよびWebアプリケーション向けの高度なセキュリティ管理機能や統合エンドポイント管理機能のほか、Content Collaboration Premiumが含まれています。</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Citrix Virtual Apps and Desktops向けのハイブリッド配備オプションを含む、包括的なワークスペースソリューションです。</p><p>Workspace Premiumの機能に加えて、Citrix Virtual Apps and Desktops向けのクラウド管理オプションが含まれています。</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentialsは、SaaSおよびWebアプリケーションへのログインプロセスの簡素化と保護を行うことにより、中小企業によるデータ保護を支援します。</p><p>SaaSおよびWebアプリケーション向けの多要素認証をサポートするシングルサインオン（SSO）が含まれており、これによりログインプロセスの保護を強化することで、アカウントへの不正アクセスが発生する確率を99.9%引き下げることができます。</p>"
            },
            terms: "*1ユーザー１ヶ月あたり",
            btn1: "機能マトリクスを見る"
        },
        features: {
            disclaimer1: "* 500ユーザー分の3年間のサブスクリプションをベースとしたユーザー単位の月額平均メーカー希望小売価格（米ドル表示）。実際の価格は変動する場合があります。<br /> Citrix Workspaceのライセンスオプションの最小ユーザー数は25ユーザーです。",
            disclaimer2: "** Workspace Premium Serviceには、オンプレミスのCitrix Virtual Apps and Desktops配備環境向けのWorkspace Analyticsは含まれていません。"
        },
        calculator: {
            edition: "エディションを選択",
            title: "価格を計算する",
            users: "ユーザーを選択",
            estCost: "お客様の月々の概算費用",
            btn1: "担当者と直接お話をする",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "ライセンスオプションの最小ユーザー数は25ユーザーです。もう一度お試しください。",
            lowUserMsg: "ユーザー数は500名未満ですか？ 当社は、中小企業のニーズに対応します。",
            volumeDiscount: "ユーザー数は2500名以上ですか？ ボリューム割引価格をご利用になれます。",
            contract1: "1年契約",
            contract3: "3年契約",
            contract3savings: "20%の削減",
            term: "*1ユーザー1か月あたり",
            disclaimer: "*このカリキュレータ―は概算価格を提供するものであり、予算編成の目的にのみ提供されているものです。実際の価格は変動する場合があります。適用される割引については、シトリックスまたはCitrixパートナーにお問い合わせください。"
        },
        stats: {
            title: "メリット",
            stat1: {
                title: "従業員エクスペリエンスを向上",
                desc: "<b>5人中4人</b>のITリーダーが、従業員エクスペリエンスはデジタルトランスフォーメーションにとって重要だと考えています。"
            },
            stat2: {
                title: "従業員に選択の自由を提供",
                desc: "<b>78%</b>のビジネスリーダーが、従業員が使用するアプリケーションやデバイスを選択できるようにすることは、従業員エクスペリエンスを向上させるのに役立つと考えています。"
            },
            stat3: {
                title: "アクセスを簡素化",
                desc: "<b>47%</b>のビジネスリーダーが、従業員エンゲージメントを高める最も大きな要因は、従業員が仕事に必要となる情報に簡単にアクセスできるようにすることだと回答しています。"
            },
            btn1: "担当者と直接お話をする",
            disclaimer: "出典：<a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}